import Vue from 'vue'
import * as service from './Location-Pool-Selector.services.js'
export default {

  data() {
    return {
      chosenLocation: '',
      chosenPool: '',
      stateName: '',
      locationSelector: '',
      poolSelector: '',
      currentRole: '',
      locations: [],
      locationname: '',
      pools: [],
      pooldisabled: true,
      sidebarToggle: false,
      showSide: true
    }
  },
  //   props:['currentrole'],
  mounted() {
    let context = this
    this.$router.app.$on('sidebar_hide', (data) => {
      if (data == true) {
        context.showSide = false
      } else {
        context.showSide = true
      }
    })
    this.$router.app.$on('invokePoolLoc', (data) => {
      context.getLocations()
      this.getpools(this.chosenLocation)
    })
    this.$router.app.$on('invocksidebar', (data) => {
      if (data) {
        context.getLocations()
      }
    })
    this.stateName = this.$route.name
    this.currentRole = window.authDetails ? window.authDetails.role : ''
    if (this.stateName != 'login' && this.stateName != 'resetpassword' && this.stateName != 'signup' && this.stateName != 'signupconfirm') {
      context.getLocations()
    }
  },
  props: ['burgerrotate'],
  watch: {
    '$route' (to, from) {
      this.showSide = true
      this.stateName = to.name
      this.currentRole = window.authDetails ? window.authDetails.role : ''
      this.getLocations()
      if (from.name == 'addpersonnel' && this.stateName != 'addpersonnel') {
        if (this.chosenLocation.LocationName == 'All') {
          this.locations.splice(this.locations.length - 1)
          this.chosenLocation = this.locations[0]
        }
      }
      if (this.stateName != 'login') {
        //FG - FOOF -aaaaaa FIX FOR NON AQUATICS DIRECTORS - GET POOLS IF THE ARRAY IS EMPTY - BELOW
    
        if(this.pools == null || this.pools.length==0) { 
          this.pools = window.poolsAtLogin;
          if( this.pools.length > 0)
            this.chosenPool=this.pools[0];
        }
        var initialPool = localStorage.getItem('initpool');
        if(initialPool == undefined || initialPool == null)
          localStorage.setItem('initialPool', this.chosenPool);           
        //


        if (localStorage.getItem('initlocation')) {
          var x = localStorage.getItem('initlocation')
          this.$router.app.$emit('emittedlocation_obj', JSON.parse(x))
          this.$router.app.$emit('emittedpool_obj', this.pools[0]) 
        }
        
      }
    },
    chosenLocation: function (val) {//alert ("INSIDE VALUE: " + JSON.stringify(val))
      localStorage.setItem('initlocation', JSON.stringify(this.chosenLocation))
      this.pools = []
      this.getpools(val.LocationId) //aaaaaa - This makes sure there are pools for the pull in 
      var val1 = val.LocationId ? val.LocationId : 0
      //FG - FOOF - March 5 2019
      this.chosenLocation.PoolId = this.chosenPool;
      this.chosenLocation.PoolName = this.poolName;
      let x = this.chosenLocation ? this.chosenLocation : 0
      this.$router.app.$emit('emittedlocation_obj', x)
      window.globallocid = val1
    },
    chosenPool: function (val) {//alert("INSIDE chosenPool: " + val)
      localStorage.setItem('initpool', JSON.stringify(this.chosenPool))
      this.$router.app.$emit('emittedpool_obj', val)
    }
  },
  methods: {
    hideSidebar() {
      this.sidebarToggle = !this.sidebarToggle
    },
    getLocations() {
      let context = this
      //FG - FOOF - Change for certification -Facility/Venue Pull In Fix
      //     Prior to the Change for certification I had changed the if statement below to always be true
      //     because after initially signing on (and initially means first time ever) the pull in for
      //     facility and venue did not contain chosenLocations at all.  The comments I made at that time
      //     appear below:
      //        20200806-FG-0001 &  20200811-FG-0001 - WHILE GOING THRU THE MAHC CONFIRMATION PROCESS I MODIFIED THE
      //        CONDITION BELOW SO IT IS ALWAYS TRUE
      //        THIS CODE NEEDS TO BE REWORKED AFTER / DURING CONFIRMATION
      //     Subsequently (in Dec of 2020) while adding code requested by Dewey for our certification I realized
      //        that the intent of the code below was that sometimes it makes no sense to have a location without
      //        a pool to be the chosen location.
      //        Turns out that its OK to have a choice of locations without pools for PersonnelDahsboard
      //        and dashboard.  They are the two landing pages for initial signon.
      //
      if (this.stateName == 'checklistlanding' 
          || this.stateName == 'chemicalrecord' 
          || this.stateName == 'activitylist' 
          //|| this.stateName == 'PersonnelDashboard' 
          || this.stateName == 'chemicalsettings' 
          || this.stateName == 'incidents' 
          //|| this.stateName == 'dashboard'
        ) {
        service.GetLocationsPools().then(function (response) {
          context.locations = response
          var lex = false
          //var yl = localStorage.getItem('initlocation') -- PRIOR TO 20200806-FG-0001
          //var xy = JSON.parse(yl)                       -- PRIOR TO 20200806-FG-0001

          //20200806-FG-0001 - below
          xy = null;
          var yl = localStorage.getItem('initlocation')
          if(yl=="undefined" || yl==null || yl == "[object Object]"){
            if(response != null && response.length > 0){
              yl=response[0];
              //localStorage.setItem('initlocation',yl); //FG - FOOF - FIX FOR NON AQUATICS DIRECTORS - aaaaaa
              localStorage.setItem('initlocation',JSON.stringify(yl));
            }
            else {
              yl = null;
            }
            xy = yl;
          }
          else {
            var xy = JSON.parse(yl);
          }
          if(xy)
             context.getpools(xy.LocationId);
          //20200806-FG-0001 - above

          if (xy) {
              /*****************************************************************
              //FG - 11-7-2018 - It seems that the object should be set as the
              //context chosenLocation regardless of whether or not the current role
              //is 'AquaticsDirector'... 
              //ALSO... shouldn't this really be checking
              //on a code chosenLocation rather than the text if it is used ?????
              //if (context.currentRole == 'AquaticsDirector') {
              *****************************************************************/
              if (context.stateName != 'addpersonnel' && context.stateName != 'PersonnelDashboard') {
                response.map(function (item, index) {
                  if (item.LocationId == xy.LocationId) {
                    lex = true
                    context.chosenLocation = response[index]
                  }
                })
                if (lex) {
                  context.$router.app.$emit('emittedlocation_obj', xy)
                  //alert("4: " + xy.LocationName)
                } else {
                  context.$router.app.$emit('emittedlocation_obj', response[0])
                  //alert("5: " + response[0].LocationName)
                  context.chosenLocation = response[0]
                }
              } else {
                //FG - FOOF - After Cert - First Release (4) - Although I could not find anyplace in the system 
                //  than made the code below put "All" in the pull in I removed commented it out
                //  for the first release anyway anyway just in case
                /*
                response.push({
                  LocationName: 'aaaAll',
                  LocationId: ''
                })
                */
              }
            //}
            /***************************************************************
            //FG - 11-7-2018 - It seems that the object should be set as the
            //context chosenLocation regardless of whether or not the current role
            //is 'AquaticsDirector'... 
            //ALSO... shouldn't this really be checking
            //on a code chosenLocation rather than the text if it is used ?????
            //COMMENTED OUT THE LINES BELOW BECAUSE OF THE COMMENT ABOVE
            *****************************************************************/
            //if (context.currentRole != 'AquaticsDirector') {
            //  context.chosenLocation = context.locations[0].LocationId
            //}

            if (context.locations.length == 1) {
              context.locationname = context.locations[0].LocationName
            }

          } else {
            /*****************************************************************
            //FG - 11-7-2018 - It seems that the object should be set as the
            //context chosenLocation regardless of whether or not the current role
            //is 'AquaticsDirector'... 
            //ALSO... shouldn't this really be checking
            //on a code chosenLocation rather than the text if it is used ?????
            //if (context.currentRole == 'AquaticsDirector') {
            *****************************************************************/
              if (context.stateName != 'addpersonnel') {
                context.chosenLocation = response[0]
              } else {
                //FG - FOOF - After Cert - First Release (4) - Although I could not find anyplace in the system 
                //  than made the code below put "All" in the pull in I removed commented it out
                //  for the first release anyway anyway just in case
                /*
                response.push({
                  LocationName: 'bbbAll',
                  LocationId: ''
                })
                */
                context.chosenLocation = response[response.length - 1]
              }
            //}
            /***************************************************************
            //FG - 11-7-2018 - It seems that the object should be set as the
            //context chosenLocation regardless of whether or not the current role
            //is 'AquaticsDirector'... 
            //ALSO... shouldn't this really be checking
            //on a code chosenLocation rather than the text if it is used ?????
            //COMMENTED OUT THE LINES BELOW BECAUSE OF THE COMMENT ABOVE
            //if (context.currentRole != 'AquaticsDirector') {
            //  context.chosenLocation = context.locations[0].LocationId
            //}
            *****************************************************************/
            if (context.locations.length == 1) {
              context.locationname = context.locations[0].LocationName
            }
          }

        }, (error) => {

        })

      } else {
        service.GetLocations().then(function (response) {

          context.locations = response
          var lex = false

          //I end up here after first login and when that happens localStorage.getItem('initlocation')
          //is null.... SO that needs to grab the chosenLocation from the first location in response
          //-- ORIG HAD THIS---->var yl = localStorage.getItem('initlocation')
          //-- ORIG HAD THIS ---->var xy = JSON.parse(yl)
          //TRY THIS FIX-BELOW
          var xy = null;
          var yl = localStorage.getItem('initlocation')
          if(yl=="undefined" || yl==null){
            if(response != null && response.length > 0){
              yl=response[0];
              //localStorage.setItem('initlocation',yl); //FG - FOOF - FIX FOR NON AQUATICS DIRCTORS - aaaaaa
              localStorage.setItem('initlocation',JSON.stringify(yl));
            }
            else
              yl = null;
            xy = yl;
          }
          else
            var xy = JSON.parse(yl);
          //TRY THIS FIX-ABOVE


          if (xy) {
            if (context.currentRole == 'AquaticsDirector') {
              if (context.stateName != 'addpersonnel' && context.stateName != 'PersonnelDashboard') {
                response.map(function (item, index) {
                 if (item.LocationId == xy.LocationId) {
                    lex = true
                    context.chosenLocation = response[index]
                  }

                })
                if (lex) {
                  context.$router.app.$emit('emittedlocation_obj', xy)
                  //alert("6: " + xy.LocationName)
                } else {
                  context.$router.app.$emit('emittedlocation_obj', response[0])
                  //alert("7: " + JSON.parse(x).response[0])
                  context.chosenLocation = response[0]
                }
              } else {
                //FG - FOOF - After Cert - First Release (4) - 
                //      ****THIS IS THE ONLY PLACE I COULD FIND THAT ********
                //     ACTUALLY PUT "All" on the pull in.  It is there for the Personell/Profile page
                //     I am removing it for the first release because it causes problems on other pages
                //     (i.e. the checklist page and others) when there are 2 facilities but only one of
                //     them has at least one venue.
                /*
                response.push({
                  LocationName: 'cccAll', 
                  LocationId: ''
                })
                */
                if (xy.LocationName == 'All' || xy.LocationName == '') {
                  context.chosenLocation = response[response.length - 1]
                } else {
                  response.map(function (item, index) {
                    if (item.LocationId == xy.LocationId) {
                      lex = true
                      context.chosenLocation = response[index]
                    }
                  })
                  if (lex) {
                    context.$router.app.$emit('emittedlocation_obj', xy)
                    //alert("8: " + xy.LocationName)
                  } else {
                    context.$router.app.$emit('emittedlocation_obj', response[0])
                    //alert("9: " + response[0].LocationName)
                    context.chosenLocation = response[0]
                  }
                }
              }
            }
            if (context.locations.length == 1) {
              context.locationname = context.locations[0].LocationName
            }

          } else {
            if (context.currentRole == 'AquaticsDirector') {
              if (context.stateName != 'addpersonnel') {
                context.chosenLocation = response[0] 
        
              } else {
                //FG - FOOF - After Cert - First Release (4) - Although I could not find anyplace in the system 
                //  than made the code below put "All" in the pull in I removed commented it out
                //  for the first release anyway anyway just in case
                /*
                response.push({
                  LocationName: 'dddAll',
                  LocationId: ''
                })
                */
                context.chosenLocation = response[response.length - 1]
              }
            }
            //FG - ???? I DID NOT GET RID OF THE LINES BELOW WHEN I MODIFIED
            //THIS CODE ON NOV 7 and 8 of 2018.... IF THERE IS A PROBLEM WITH
            //THE LOC ID BEING EMPTY (resulting in a pull in error... the one
            //I WAS SEEING WAS CHECKLIST 2 - error while submit) THEN THE CODE
            //BELOW IS THE LIKELY CULPRIT.
            if (context.currentRole != 'AquaticsDirector') {
              context.chosenLocation = context.locations[0].LocationId
            }

            if (context.locations.length == 1) {
              context.locationname = context.locations[0].LocationName
            }

          }

        }, (error) => {

        })

      }

    },
    getpools(locationid) {
      let context = this


      service.GetPools(locationid).then(function (response) {


        if (response) {
          var lex = false
          var yl = localStorage.getItem('initpool')
          var xy = JSON.parse(yl)
          context.pooldisabled = false
          context.pools = response

          response.map(function (item, index) {

            if (item.PoolId == xy.PoolId) {
              lex = true
              context.chosenPool = response[index]
            }

          })

          if (lex) {
            context.$router.app.$emit('emittedpool_obj', xy)
          } else {
            context.chosenPool = response[0]
          }

        } else {
          context.pooldisabled = true
        }

      }, (error) => {

      })
    },
  }

}




// WEBPACK FOOTER //
// ./src/components/Location-Pool-Selector/Location-Pool-Selector.js